import { signalsSchema } from "../schemas/index.js";
/**
 * `GET /flow/v1/signals` — a curated, explained feed of actionable signals (today all
 * `signal_type:"arbitrage"`). Live updates arrive on the `signal` WS channel as
 * `signal.update` events, pushed per contest (an empty `signals` array clears that contest).
 */
export class SignalsResource {
    http;
    constructor(http) {
        this.http = http;
    }
    list(params = {}) {
        return this.http.request({
            method: "GET",
            path: "/signals",
            endpoint: "signals.list",
            query: {
                contest_id: params.contest_id,
                league_id: params.league_id,
                signal_type: params.signal_type,
                status: params.status,
                min_strength: params.min_strength,
                limit: params.limit,
                cursor: params.cursor,
            },
            dataSchema: signalsSchema,
        });
    }
}
//# sourceMappingURL=signals.js.map